import { styled, Card, Chip } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

export const CustomPlanInfoCardRoot = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isRecommended',
})<{ isRecommended: boolean }>(({ theme, isRecommended }) => ({
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  position: 'relative',

  ...(isRecommended && {
    borderColor: '#000',
    paddingTop: theme.spacing(3),
    overflow: 'visible',
    marginTop: theme.spacing(2),
  }),
}));

export const CustomPlanInfoCardCheckIcon = styled(CheckIcon)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(17),
  color: '#000',
  marginTop: 2,
  marginRight: theme.spacing(1),
}));

export const CustomPlanCardRecommendedChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(9),
  fontWeight: theme.typography.fontWeightBold,
  borderRadius: 20,
  backgroundColor: '#000',
  color: theme.palette.getContrastText('#000'),
  position: 'absolute',
  top: theme.spacing(-1.5),
  right: theme.spacing(2),
}));
